import { useEffect } from "react";
import React, { useState } from "react";
import SectionTitle from "../components/SectionTitle";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import meetVendors from "../assets/lottie-files/meetVendors.lottie";

const MeetOurVendors = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const containerId = "vendor-embed-container";
    const container = document.getElementById(containerId);
    if (!container) return;

    // Clear container (important for React re-mounts)
    container.innerHTML = "";

    // Remove any previously injected MarketWurks script
    const oldScript = document.querySelector(
      'script[src="https://app.marketwurks.com/assets/embed.js"]'
    );
    if (oldScript) {
      oldScript.remove();
    }

    const script = document.createElement("script");
    script.src = "https://app.marketwurks.com/assets/embed.js";
    script.async = true;

    script.setAttribute("data-resource-id", "profiles");
    script.setAttribute("data-org-id", "2059e9ddd0a241ff86ccb7d0189dbe64");

    script.onload = () => {
      setLoading(false);
    };

    // CRITICAL: script must be appended inside the container
    container.appendChild(script);
  }, []);

  return (
    <div className="vendor-page">
      <div
        style={{
          background:
            "linear-gradient(to bottom right, #D46540 65%, rgb(253, 243, 187) 100%)",
          padding: "4rem 1rem",
          color: "white",
        }}
      >
        <div style={styles.contentWrapper}>
          <div style={styles.textWrapper}>
            <SectionTitle
              parts={[{ text: "🛍️ Meet Our Vendors", color: "white" }]}
              align="left"
            />
            <p style={{ fontSize: "1.25rem", lineHeight: "1.6" }}>
              Discover the local farmers, bakers, crafters, and artists who make
              the St. John’s Farmers’ Market a vibrant hub of community life.
              Each brings unique creations—from fresh produce to handmade goods
              and Newfoundland-inspired art. Explore their profiles below to
              meet the people behind your favorite market finds.
            </p>
          </div>

          <div style={styles.lottieWrapper}>
            <DotLottieReact
              src={meetVendors}
              loop
              autoplay
              style={{
                width: "100%",
                // maxWidth: "450px",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          background: "#fff",
          padding: "2.5rem 1rem",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "2rem 0",
          }}
        >
          {loading && (
            <div style={{ textAlign: "center", marginBottom: "1rem" }}>
              Loading vendors...
            </div>
          )}
          <div
            id="vendor-embed-container"
            style={{
              background: "#f8f8f8",
              borderRadius: "1rem",
              padding: "2rem",
              minHeight: "300px",
              boxShadow: "0 2px 12px rgba(212,101,64,0.07)",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "2rem",
  } as React.CSSProperties,
  textWrapper: {
    flex: "1 1 500px",
    minWidth: "300px",
  } as React.CSSProperties,
  lottieWrapper: {
    flex: "1 1 400px",
    minWidth: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as React.CSSProperties,
};

export default MeetOurVendors;
